import { forwardRef } from 'react';
import { StyledLabel, StyledInput, StyledSwitch } from './styled';

const Toggle = forwardRef((props, ref) => {
  const { children, ...rest } = props;

  return (
    <>
      {children}
      <StyledLabel>
        <StyledInput type="checkbox" ref={ref} {...rest} />
        <StyledSwitch />
      </StyledLabel>
    </>
  );
});

export default Toggle;
